<div class="asset-creation-container">
  <div class="asset-form-wrapper">
    <!-- Success Message -->
    <div *ngIf="successFlag" class="success-message">
      <mat-icon class="success-icon">check_circle</mat-icon>
      <span>{{ description }}</span>
    </div>

    <form [formGroup]="assetsForm" class="asset-form">
      <!-- Header Section -->
      <div class="row">
        <h1 class="title">Create New Asset</h1>
      </div>

      <!-- Asset Details Section -->
      <div class="form-section asset-details-section">
        <h2 class="section-title">
          <mat-icon>info</mat-icon>
          Asset Details
        </h2>
        <div class="form-row">
          <div class="form-field-wrapper">
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Select Asset Type</mat-label>
              <select
                matNativeControl
                required
                [(ngModel)]="selectedAsset"
                (change)="onSelectionChange($event)"
                formControlName="assetType"
              >
                <option *ngFor="let asset of assetsList" [value]="asset.name">
                  {{ asset.name }}
                </option>
              </select>
              <mat-hint>Choose the type of asset you want to create</mat-hint>
            </mat-form-field>
          </div>
          <div class="form-field-wrapper employee-field">
            <app-active-emp
              (empName)="empNameSelected($event)"
            ></app-active-emp>
          </div>
          <div class="form-field-wrapper">
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Employee Assign Date</mat-label>
              <input
                matInput
                [matDatepicker]="empAssignedDate"
                formControlName="empAssignedDate"
                [attr.required]="
                  selectedAsset !== 'SIM' && selectedAsset !== 'Fuel Card'
                    ? true
                    : null
                "
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="empAssignedDate"
              ></mat-datepicker-toggle>
              <mat-datepicker #empAssignedDate></mat-datepicker>
              <mat-error
                *ngIf="
                  assetsForm.get('empAssignedDate')?.invalid &&
                  assetsForm.get('empAssignedDate')?.touched
                "
              >
                Employee assign date is required
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="form-row">
          <div class="form-field-wrapper comments-field">
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Comments</mat-label>
              <textarea
                matInput
                formControlName="comments"
                rows="3"
                [attr.required]="
                  selectedAsset !== 'SIM' && selectedAsset !== 'Fuel Card'
                    ? true
                    : null
                "
              ></textarea>
              <mat-hint>Provide any additional comments or notes</mat-hint>
              <mat-error
                *ngIf="
                  assetsForm.get('comments')?.invalid &&
                  assetsForm.get('comments')?.touched
                "
              >
                Comments are required
              </mat-error>
            </mat-form-field>
          </div>
          <div class="form-field-wrapper" *ngIf="selectedAsset === 'SIM'">
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Mobile Number</mat-label>
              <input matInput formControlName="mobileNumber" required />
              <mat-error
                *ngIf="
                  assetsForm.get('mobileNumber')?.invalid &&
                  assetsForm.get('mobileNumber')?.touched
                "
              >
                Mobile number is required
              </mat-error>
            </mat-form-field>
          </div>
          <div class="form-field-wrapper" *ngIf="selectedAsset === 'Fuel Card'">
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Fuel Card</mat-label>
              <input matInput formControlName="fuelCard" required />
              <mat-error
                *ngIf="
                  assetsForm.get('fuelCard')?.invalid &&
                  assetsForm.get('fuelCard')?.touched
                "
              >
                Fuel card is required
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- Car Details Section -->
      <div
        class="form-section car-details-section"
        formGroupName="assetCar"
        *ngIf="selectedAsset === 'Car'"
      >
        <h2 class="section-title">
          <mat-icon>directions_car</mat-icon>
          Car Details
        </h2>
        <div class="form-row">
          <div class="form-field-wrapper">
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Make</mat-label>
              <input matInput formControlName="make" required />
              <mat-error
                *ngIf="
                  assetsForm.get('assetCar.make')?.invalid &&
                  assetsForm.get('assetCar.make')?.touched
                "
              >
                Make is required
              </mat-error>
            </mat-form-field>
          </div>
          <div class="form-field-wrapper">
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Model</mat-label>
              <input matInput formControlName="model" required />
              <mat-error
                *ngIf="
                  assetsForm.get('assetCar.model')?.invalid &&
                  assetsForm.get('assetCar.model')?.touched
                "
              >
                Model is required
              </mat-error>
            </mat-form-field>
          </div>
          <div class="form-field-wrapper">
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Registration Number</mat-label>
              <input matInput formControlName="number" required />
              <mat-error
                *ngIf="
                  assetsForm.get('assetCar.number')?.invalid &&
                  assetsForm.get('assetCar.number')?.touched
                "
              >
                Registration number is required
              </mat-error>
              <mat-error
                *ngIf="
                  assetsForm
                    .get('assetCar.number')
                    ?.hasError('modelSerialInvalid') &&
                  assetsForm.get('assetCar.number')?.touched
                "
              >
                {{ assetValidationError }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="form-field-wrapper">
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Color</mat-label>
              <input matInput formControlName="color" required />
              <mat-error
                *ngIf="
                  assetsForm.get('assetCar.color')?.invalid &&
                  assetsForm.get('assetCar.color')?.touched
                "
              >
                Color is required
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="form-row">
          <div class="form-field-wrapper">
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Chasis Number</mat-label>
              <input matInput formControlName="chasisNumber" required />
              <mat-error
                *ngIf="
                  assetsForm.get('assetCar.chasisNumber')?.invalid &&
                  assetsForm.get('assetCar.chasisNumber')?.touched
                "
              >
                Chasis number is required
              </mat-error>
            </mat-form-field>
          </div>
          <div class="form-field-wrapper">
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Fuel Type</mat-label>
              <select matNativeControl required formControlName="fuelType">
                <option value="petrol">Petrol</option>
                <option value="diesel">Diesel</option>
                <option value="electric">Electric</option>
                <option value="hybrid">Hybrid</option>
              </select>
            </mat-form-field>
          </div>
          <div class="form-field-wrapper">
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Carbon Emission</mat-label>
              <input
                matInput
                type="number"
                formControlName="carbonEmission"
                required
              />
              <mat-error
                *ngIf="
                  assetsForm.get('assetCar.carbonEmission')?.invalid &&
                  assetsForm.get('assetCar.carbonEmission')?.touched
                "
              >
                Carbon emission is required
              </mat-error>
            </mat-form-field>
          </div>
          <div class="form-field-wrapper">
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Catalogue Price(€)</mat-label>
              <input
                matInput
                type="number"
                formControlName="cataloguePrice"
                required
              />
              <mat-error
                *ngIf="
                  assetsForm.get('assetCar.cataloguePrice')?.invalid &&
                  assetsForm.get('assetCar.cataloguePrice')?.touched
                "
              >
                Catalogue price is required
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="form-row">
          <div class="form-field-wrapper">
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Category</mat-label>
              <select
                matNativeControl
                required
                formControlName="assetCategory"
                [(ngModel)]="assetCategorySelected"
                (change)="updateFormValidators()"
              >
                <option value="Leased">Leased</option>
                <option value="Own">Own</option>
                <option value="Rent">Rent</option>
              </select>
            </mat-form-field>
          </div>
          <div
            class="form-field-wrapper"
            *ngIf="
              assetCategorySelected === 'Leased' ||
              assetCategorySelected === 'Rent'
            "
          >
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Lease End Date</mat-label>
              <input
                matInput
                [matDatepicker]="leaseEndDate"
                formControlName="leaseEndDate"
                required
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="leaseEndDate"
              ></mat-datepicker-toggle>
              <mat-datepicker #leaseEndDate></mat-datepicker>
              <mat-error
                *ngIf="
                  assetsForm.get('assetCar.leaseEndDate')?.invalid &&
                  assetsForm.get('assetCar.leaseEndDate')?.touched
                "
              >
                Lease end date is required
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- Electronic Device Details Section -->
      <div
        class="form-section electronic-details-section"
        formGroupName="assetElectronic"
        *ngIf="
          selectedAsset === 'Laptop' ||
          selectedAsset === 'Monitor' ||
          selectedAsset === 'Mobile' ||
          selectedAsset === 'Other'
        "
      >
        <h2 class="section-title">
          <mat-icon>devices</mat-icon>
          Device Details
        </h2>
        <div class="form-row">
          <div class="form-field-wrapper">
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Model</mat-label>
              <input matInput formControlName="electronicModel" required />
              <mat-error
                *ngIf="
                  assetsForm.get('assetElectronic.electronicModel')?.invalid &&
                  assetsForm.get('assetElectronic.electronicModel')?.touched
                "
              >
                Model is required
              </mat-error>
            </mat-form-field>
          </div>
          <div class="form-field-wrapper">
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Serial Number</mat-label>
              <input
                matInput
                formControlName="electronicSerialNumber"
                required
              />
              <mat-error
                *ngIf="
                  assetsForm.get('assetElectronic.electronicSerialNumber')
                    ?.invalid &&
                  assetsForm.get('assetElectronic.electronicSerialNumber')
                    ?.touched
                "
              >
                Serial number is required
              </mat-error>
              <mat-error *ngIf="assetValidationError">
                {{ assetValidationError }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="form-field-wrapper">
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Price(€)</mat-label>
              <input
                matInput
                type="number"
                formControlName="electronicPrice"
                required
              />
              <mat-error
                *ngIf="
                  assetsForm.get('assetElectronic.electronicPrice')?.invalid &&
                  assetsForm.get('assetElectronic.electronicPrice')?.touched
                "
              >
                Price is required
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>

      <div
        class="form-section electronic-details-section"
        *ngIf="
          selectedAsset === 'Car' ||
          selectedAsset === 'Laptop' ||
          selectedAsset === 'Monitor' ||
          selectedAsset === 'Mobile'
        "
      >
        <div class="form-row">
          <div class="form-field-wrapper">
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Asset Start Date</mat-label>
              <input
                matInput
                [matDatepicker]="assetStartDatePicker"
                formControlName="assetStartDate"
                required
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="assetStartDatePicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #assetStartDatePicker></mat-datepicker>
              <mat-error
                *ngIf="
                  assetsForm.get('assetStartDate')?.invalid &&
                  assetsForm.get('assetStartDate')?.touched
                "
              >
                Asset start date is required
              </mat-error>
            </mat-form-field>
          </div>
          <div class="form-field-wrapper">
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Asset End Date</mat-label>
              <input
                matInput
                [matDatepicker]="assetEndDatePicker"
                formControlName="assetEndDate"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="assetEndDatePicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #assetEndDatePicker></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
        <div class="form-row">
          <div class="form-field-wrapper">
            <mat-checkbox formControlName="insurance">Insurance</mat-checkbox>
          </div>
        </div>
        <div class="form-row" *ngIf="assetsForm.get('insurance')?.value">
          <div class="form-field-wrapper">
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Insurance Start Date</mat-label>
              <input
                matInput
                [matDatepicker]="insuStartDatePicker"
                formControlName="insuStartDate"
                required
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="insuStartDatePicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #insuStartDatePicker></mat-datepicker>
              <mat-error
                *ngIf="
                  assetsForm.get('insuStartDate')?.invalid &&
                  assetsForm.get('insuStartDate')?.touched
                "
              >
                Insurance start date is required
              </mat-error>
            </mat-form-field>
          </div>
          <div class="form-field-wrapper">
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Insurance End Date</mat-label>
              <input
                matInput
                [matDatepicker]="insuEndDatePicker"
                formControlName="insuEndDate"
                required
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="insuEndDatePicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #insuEndDatePicker></mat-datepicker>
              <mat-error
                *ngIf="
                  assetsForm.get('insuEndDate')?.invalid &&
                  assetsForm.get('insuEndDate')?.touched
                "
              >
                Insurance end date is required
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="form-row">
          <div class="form-field-wrapper">
            <mat-checkbox formControlName="warranty">Warranty</mat-checkbox>
          </div>
        </div>
        <div class="form-row" *ngIf="assetsForm.get('warranty')?.value">
          <div class="form-field-wrapper">
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Warranty Start Date</mat-label>
              <input
                matInput
                [matDatepicker]="warStartDatePicker"
                formControlName="warStartDate"
                required
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="warStartDatePicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #warStartDatePicker></mat-datepicker>
              <mat-error
                *ngIf="
                  assetsForm.get('warStartDate')?.invalid &&
                  assetsForm.get('warStartDate')?.touched
                "
              >
                Warranty start date is required
              </mat-error>
            </mat-form-field>
          </div>
          <div class="form-field-wrapper">
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Warranty End Date</mat-label>
              <input
                matInput
                [matDatepicker]="warEndDatePicker"
                formControlName="warEndDate"
                required
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="warEndDatePicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #warEndDatePicker></mat-datepicker>
              <mat-error
                *ngIf="
                  assetsForm.get('warEndDate')?.invalid &&
                  assetsForm.get('warEndDate')?.touched
                "
              >
                Warranty end date is required
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
    </form>

    <!-- Submit Button -->
    <div class="form-actions">
      <button
        mat-raised-button
        color="primary"
        class="submit-button"
        (click)="onSubmit()"
        [disabled]="!assetsForm.valid || isCheckingModelSerial || disableBtn"
        type="submit"
      >
        <mat-icon>add</mat-icon>
        Create Asset
      </button>
    </div>
  </div>
</div>
